/* TypeScript file generated from OverlayTriggerView.resi by genType. */

/* eslint-disable */
/* tslint:disable */

import * as OverlayTriggerViewJS from './OverlayTriggerView.res.js';

import type {t as LegacyIcon_t} from '../../../src/resources/images-and-icons/LegacyIcon.gen';

export type size = "normal" | "compact";

export type inputFieldPresetProps = {
  readonly required: boolean; 
  readonly tooltip?: JSX.Element; 
  readonly errorMessage?: string
};

export type preset = 
    "filter"
  | { NAME: "inputField"; VAL: inputFieldPresetProps };

export type props<children,preset,size,growContent,label,icon,hideIcon,hovered,active,focused,highlighted,disabled> = {
  readonly children: children; 
  readonly preset: preset; 
  readonly size?: size; 
  readonly growContent?: growContent; 
  readonly label?: label; 
  readonly icon?: icon; 
  readonly hideIcon?: hideIcon; 
  readonly hovered: hovered; 
  readonly active?: active; 
  readonly focused?: focused; 
  readonly highlighted?: highlighted; 
  readonly disabled?: disabled
};

export const make: React.ComponentType<{
  readonly children: React.ReactNode; 
  readonly preset: preset; 
  readonly size?: size; 
  readonly growContent?: boolean; 
  readonly label?: string; 
  readonly icon?: LegacyIcon_t; 
  readonly hideIcon?: boolean; 
  readonly hovered: boolean; 
  readonly active?: boolean; 
  readonly focused?: boolean; 
  readonly highlighted?: boolean; 
  readonly disabled?: boolean
}> = OverlayTriggerViewJS.make as any;
